import { render, staticRenderFns } from "./COM_Footer.vue?vue&type=template&id=17d831f9&"
import script from "./COM_Footer.vue?vue&type=script&lang=js&"
export * from "./COM_Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d831f9')) {
      api.createRecord('17d831f9', component.options)
    } else {
      api.reload('17d831f9', component.options)
    }
    module.hot.accept("./COM_Footer.vue?vue&type=template&id=17d831f9&", function () {
      api.rerender('17d831f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/COM_Footer.vue"
export default component.exports